module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4BAMAAADLSivhAAAAMFBMVEUAAABmiM1micxniMxnh8xmiMx0k9GGodeUq9umuuGxwuXCz+vR2/Df5vTx9Pr///8bfxSGAAAABXRSTlMAa32as6ujDRYAAAABYktHRA8YugDZAAAApUlEQVRYw+3ZvQ3CMBCGYSdiICQWSMEAblyAGCBDZIB0TENFnS4DMAQttfMLfb5zg/N+/SNblu+KO+f+NOVZTDXiQxDjJ3ztpXQzvr1aJZ8Fd9Ktv7gRbv3D97g9YHD2uBbKOaSo57fUhlYcpSRpQybM9wSDwWAwGAwGg8FgMAOHXAcOppNtAwfTa/O3wbli0zbBUpKWDcrlKeXhrVuj4iTm6PaYAY/loUVd7dvHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/page.png
// module id = qmR4
// module chunks = 1